export function wrapPageInSmoothWrapper() {
  if (typeof document !== "undefined") {
    const content = document.querySelector("#___gatsby")
    const smoothContent = document.createElement("div")
    const smoothWrapper = document.createElement("div")
    smoothContent.setAttribute("id", "smooth-content")
    smoothWrapper.setAttribute("id", "smooth-wrapper")
    if (content) {
      smoothContent.appendChild(content)
      smoothWrapper.appendChild(smoothContent)
      document.body.appendChild(smoothWrapper)
    }
  }
}
